import react from 'react';
import './PrimaryCommericialSub.css';
import AIheader from '../../../pages/RentAI/AIheader';
import BannerCommericial from './BannerCommericial/BannerCommericial';
import OnRent from './OnRent/OnRent';
import OffRentInsurance from './OffRentInsurance/OffRentInsurance';
import PersonalActivities from './PersonalActivities/PersonalActivities';
import MoreSolutionsShield from '../MoreSolutionsShield/MoreSolutionsShield';
 
// import PopularTopics from '../../Rentid2/PopularTopics/PopularTopics';
import Footer from '../../Footer/Footer';
 

const PrimaryCommericialSub = ()=>{
    return(
        <>
          <AIheader/>
          <BannerCommericial/>
          <OnRent/>
          <OffRentInsurance/>
          <PersonalActivities/>
          <MoreSolutionsShield/>
          {/* <PopularTopics/> */}
          <Footer/>
        </>
    )
}

export default PrimaryCommericialSub;